import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { Transition } from '@headlessui/react';
import classNames from 'classnames';
import { Button } from '../Button/Button.es.js';
import { Icon } from '../Icon/Icon.es.js';

const Notification = ({ title, children, onSubmit = undefined, submitLabel, submitDisabled, locale = {
    close: 'Close'
}, className, open, onDismiss, dismissLabel, autoDismiss, ...rest })=>{
    const NotificationClass = classNames(// Base Alert Style
    'cb-notification', className);
    useEffect(()=>{
        if (autoDismiss) {
            // arbitrary timeout of 3s for dismiss. Option not given to ensure consistency.
            setTimeout(onDismiss, 3000);
        }
    }, [
        autoDismiss,
        onDismiss
    ]);
    return jsx("div", {
        className: NotificationClass,
        ...rest,
        children: jsx(Transition, {
            as: "div",
            className: "w-96",
            enter: "transform ease-out duration-300 transition",
            enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
            enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
            leave: "transition ease-in duration-100",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            show: open,
            children: jsx("div", {
                className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-md bg-surface-primary shadow-lg",
                children: jsxs("div", {
                    className: "p-4",
                    children: [
                        jsxs("div", {
                            className: "flex items-start",
                            children: [
                                jsxs("div", {
                                    className: "w-0 flex-1 pt-0.5",
                                    children: [
                                        jsx("p", {
                                            className: "title",
                                            "data-testid": "title",
                                            children: title
                                        }),
                                        jsx("div", {
                                            className: "body",
                                            "data-testid": "body",
                                            children: children
                                        })
                                    ]
                                }),
                                jsx("div", {
                                    className: "ml-4 flex shrink-0",
                                    children: jsx(Button, {
                                        label: locale.close,
                                        onClick: onDismiss,
                                        size: "sm",
                                        variant: "secondary",
                                        iconOnly: true,
                                        children: jsx(Icon, {
                                            name: "XSolid",
                                            size: 20
                                        })
                                    })
                                })
                            ]
                        }),
                        jsxs("div", {
                            children: [
                                dismissLabel && jsx(Button, {
                                    className: "mr-3 mt-4",
                                    "data-testid": "dismissBtn",
                                    onClick: onDismiss,
                                    size: "sm",
                                    type: "button",
                                    variant: "secondary",
                                    children: dismissLabel
                                }),
                                onSubmit && !autoDismiss && submitLabel && jsx(Button, {
                                    className: "mt-4",
                                    "data-testid": "submitBtn",
                                    disabled: submitDisabled,
                                    onClick: onSubmit,
                                    size: "sm",
                                    type: "button",
                                    variant: "primary",
                                    children: submitLabel
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
Notification.displayName = 'Notification';

export { Notification, Notification as default };
//# sourceMappingURL=Notification.es.js.map
